<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
a:-webkit-any-link {
  color: -webkit-link;
  cursor: pointer;
  text-decoration: underline;
  text-decoration: none;
}
* {
  margin: 0;
  padding: 0;
}
ul{
  list-style: none;
  margin: 0;
  padding: 0;
}
.swiper-pagination-bullet{
  background: #fff!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue